(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk2-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  var links=document.querySelectorAll('.kk2-jump a');
  if(!links.length||!('IntersectionObserver' in window))return;
  var map={};links.forEach(function(a){map[a.getAttribute('href').slice(1)]=a;});
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting&&map[e.target.id]){links.forEach(function(l){l.classList.remove('is-active');});map[e.target.id].classList.add('is-active');}});},{rootMargin:'-45% 0px -50% 0px'});
  Object.keys(map).forEach(function(id){var el=document.getElementById(id);if(el)io.observe(el);});
})();
(function(){
  document.querySelectorAll('[data-kk2-rev]').forEach(function(root){
    var track=root.querySelector('.kk2-rev__track');
    var dotsBox=root.querySelector('.kk2-rev__dots');
    var cards=track?track.children:[];
    if(!track||cards.length<2)return;
    var timer=null,dots=[];
    function gap(){return parseFloat(getComputedStyle(track).columnGap)||20;}
    function step(){return cards[0].getBoundingClientRect().width+gap();}
    function maxScroll(){return track.scrollWidth-track.clientWidth;}
    function positions(){return Math.max(1,Math.round(maxScroll()/step())+1);}
    function buildDots(){
      dotsBox.innerHTML='';dots=[];
      for(var i=0;i<positions();i++){
        (function(i){
          var b=document.createElement('button');b.type='button';b.className='kk2-rev__dot';
          b.addEventListener('click',function(){track.scrollTo({left:i*step(),behavior:'smooth'});});
          dotsBox.appendChild(b);dots.push(b);
        })(i);
      }
      mark();
    }
    function mark(){
      var i=Math.min(dots.length-1,Math.round(track.scrollLeft/step()));
      dots.forEach(function(d,k){d.classList.toggle('is-on',k===i);});
    }
    function go(dir){
      var x=track.scrollLeft+dir*step();
      if(dir>0&&track.scrollLeft>=maxScroll()-4)x=0;
      else if(dir<0&&track.scrollLeft<=4)x=maxScroll();
      track.scrollTo({left:x,behavior:'smooth'});
    }
    root.querySelectorAll('.kk2-rev__btn').forEach(function(b){
      b.addEventListener('click',function(){go(parseInt(b.getAttribute('data-dir'),10));});
    });
    track.addEventListener('scroll',function(){window.requestAnimationFrame(mark);},{passive:true});
    window.addEventListener('resize',buildDots);
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function start(){if(reduce||timer)return;timer=setInterval(function(){go(1);},5500);}
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);
    root.addEventListener('focusin',stop);root.addEventListener('focusout',start);
    root.addEventListener('touchstart',stop,{passive:true});
    buildDots();start();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
